module.exports = __webpack_public_path__ + "img/cargo-wagon-shadow-2.1c36ae64.png";